module.exports = "/_next/static/images/73e207bebb5f11ca41d5e4b7f564b029-mateo_1@3x.png";